import React from 'react';
import ComingSoon from 'components/ComingSoon';

export default function () {
  return (
    <ComingSoon />
  );
}
